<template>
	<div class="my-4">
		<AppDescription :message-list="messageList" use-background-color />
	</div>
</template>

<script>
import AppDescription from '@/components/UI/AppDescription';

export default {
	components: {
		AppDescription,
	},
	computed: {
		messageList() {
			return [
				'※ 관리서비스 10회 시 텐텐쿠폰이 발행됩니다.',
				'※ 텐텐쿠폰은 My 쿠폰함에서 확인할 수 있습니다.',
				'※ 텐텐쿠폰은 매월 초 일괄발행되며, 유효기간은 발행일로부터 1년입니다.',
				'※ 텐텐쿠폰은 제품당 1회 적용 가능하며, 기성가발 중 일부제품은 사용에서 제외됩니다.',
				'※ 최근 2년 이내 받은 관리서비스만 횟수에 산정됩니다.',
				'※ 발급 된 스탬프를 터치 하시면 상세 내역이 나타납니다.',
				'※ 제품구매시 지급되는 무상관리(3회), 생일쿠폰 등으로 사용된 건은 이용 횟수 산정에서 제외됩니다.',
				'※ 관리서비스 횟수는 2022년 1월 2일 이후 관리서비스 이용부터 산정됩니다.',
			];
		},
	},
};
</script>
